

<section>
	<p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
		[resizable]="true" [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '90vw'}">

		<ng-template pTemplate="header">
			<CustomTitle [title]="title" />
		</ng-template>

		<ng-template pTemplate="content">
			<custom-table [config]="customTable">
      </custom-table>
		</ng-template>

    <ng-template pTemplate="footer">			
		</ng-template>
	</p-dialog>
</section>
